import { render, staticRenderFns } from "./WorkflowFieldSelector.vue?vue&type=template&id=a2afc7a6&scoped=true"
import script from "./WorkflowFieldSelector.vue?vue&type=script&lang=js"
export * from "./WorkflowFieldSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2afc7a6",
  null
  
)

export default component.exports